// extracted by mini-css-extract-plugin
export default {"error":"TransactionOptionModal_error__1FKlW"};